import { ReactElement } from "react";
import { IMenuButton } from "../types";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button } from "@mui/material";

interface IProps {
  option: IMenuButton;
  callback: (option: IMenuButton, back: boolean) => void;
  back: boolean;
  selected: boolean;
}

const divStyles = {
  buttonArea: {
    width: 26,
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
  },
  buttonAreaSelected: {
    width: 26,
    height: "100%",
    background: "rgba(255, 255, 255, 0.5)",
  }
};

const MenuOption = ({ option, callback, back, selected }: IProps ): ReactElement => {
//
  return(
    <Button className={`scroll-hidden menu-button ${back ? "menu-button-back" : `menu-button-${option.disabled ? "disabled" : option.color}` }`}
      disabled={option.disabled}
      onClick={() => callback(option, back)} >
      {!back &&
      <div className="display-flex-row align-items-center justify-content-center h-100 w-100">
        <div className={"display-flex-column justify-content-center align-items-center "}
          style={selected ? divStyles.buttonAreaSelected : divStyles.buttonArea}>
          {option.icon}
        </div>
        <strong className={back ? "menu-option-90" : "flex-grow-1"}>
          {option.title}
        </strong>
      </div>
      }
      {back && <KeyboardArrowLeftIcon/>}
      {!back && option.children && option.children.length > 0 && <KeyboardArrowDownIcon/>}
    </Button>
  );
};

export default MenuOption;
